import { ContactsApiProvider } from './contactsapi.services';

export const fetchMemberAppointments = (memberKey, start = null, end = null, type = 'OpportunityAppointment') => {
  return ContactsApiProvider.get(`/members/${memberKey}/events?type=${type}&start=${start}&end=${end}`);
};

export const fetchContactAppointments = (contactId, start = null, end = null, type = null) => {
  return ContactsApiProvider.get(`/contacts/${contactId}/events?type=${type}&start=${start}&end=${end}`);
};

export const fetchCalendars = (cobrandCalendar = true) => {
  return ContactsApiProvider.get(`/calendars?cobrandCalendar=${cobrandCalendar}`);
};

export const fetchAppointment = (appointmentId) => (dispatch, getState) => {
  const { appointments = {} } = getState();
  const { calendar = {} } = appointments;
  return dispatch(ContactsApiProvider.get(`/calendars/${calendar.calendarKey}/events/${appointmentId}`));
};

export const putUpdateAppointment = (appointmentId, appointment) => (dispatch, getState) => {
  const { appointments = {} } = getState();
  const { calendar = {} } = appointments;
  return dispatch(ContactsApiProvider.put(`/calendars/${calendar.calendarKey}/events/${appointmentId}`, appointment));
};

export const fetchEventDispositions = (eventStatusId) => {
  return ContactsApiProvider.get(`calendareventstatus/${eventStatusId}/dispositions?active=true`);
};

// TODO: update/cancel/reschedule end points have to be updated here.
